<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Instrument Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <template v-if="analysis_collection.length">
      <b-form-group class="mb-3">
        <div class="row">
          <div
            class="col-md-12"
            v-for="(analysis, index) in analysis_collection"
            :key="index"
          >
            <b-form-checkbox
              :key="analysis.id"
              :value="analysis.id"
              v-model="checked"
              :name="analysis.id"
            >
              <strong>{{ analysis.analyte.name }}</strong
              >: {{ analysis.measurement_method || analysis.name }}
              <b-badge
                v-if="analysis.modus_name"
                v-b-tooltip.hover
                title="MODUS nomenclature"
                variant="light"
                class="ml-1 mr-1 text-muted"
                pill
              >
                <i class="fa fa-leaf" /> {{ analysis.modus_name }}
              </b-badge>
              <b-badge
                v-if="analysis.measurement_method"
                v-b-tooltip.hover
                title="Measurement method"
                variant="light"
                class="ml-1 mr-1 text-muted"
                pill
              >
                <i class="fa fa-ruler" />
                {{ analysis.measurement_method }}
              </b-badge>
              <b-badge
                v-if="analysis.extraction_method"
                v-b-tooltip.hover
                title="Extraction method"
                variant="light"
                class="ml-1 mr-1 text-muted"
                pill
              >
                <i class="fa fa-eye-dropper" />
                {{ analysis.extraction_method }}
              </b-badge>
            </b-form-checkbox>
          </div>
        </div>
      </b-form-group>
      <custom-table-pagination
        :options="per_page_options"
        :current_page="current_page"
        :per_page="per_page"
        :total_rows="total_rows"
        @update="updatePaginationData"
      />
    </template>
    <b-alert v-else show>
      <i class="fa fa-exclamation-circle" /> No available analyses for selected
      instrument(s).
    </b-alert>
  </div>
</template>

<script>
import CustomTablePagination from "@/components/shared/CustomTablePagination";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const AnalysisRepository = LabRepositoryFactory.get("analysis");

export default {
  name: "TaskAnalysisForm",
  components: {
    CustomTablePagination,
  },
  props: {
    sample_type: {
      type: Object,
      default: () => null,
    },
    task_analyses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: true,
      analysis_collection: null,
      current_page: 1,
      per_page: 10,
      total_rows: 10,
      per_page_options: [10, 15, 20],
    };
  },
  computed: {
    checked: {
      get() {
        return this.task_analyses;
      },
      set(value) {
        this.$emit("pickAnalyses", value);
      },
    },
  },
  methods: {
    updatePaginationData({ field, value }) {
      this[field] = value;
      field === "per_page" && (this.current_page = 1);
      this.fetchAnalyses();
    },
    updateFormData(data, total) {
      this.total_rows = total;
      this.analysis_collection = data;
    },

    async fetchAnalyses() {
      this.loading = true;

      const { per_page, current_page } = this;
      const { data } = await AnalysisRepository.getSome({
        connections: ["analyte", "instrument_tests"],
        filters: [
          {
            field: "analyte.sample_type_id",
            value: [this.sample_type.id],
          },
        ],
        sort: [
          {
            field: "analyte.name",
            value: "ASC",
          },
        ],
        limit: per_page,
        page: current_page,
      });

      this.updateFormData(data.data, data.total);

      this.loading = false;
    },
  },
  created() {
    this.fetchAnalyses();
  },
};
</script>
